import { graphql } from 'relay-runtime';

export const UNIFIED_FORUMS_GROUPS_QUERY = graphql`
  query UnifiedForumsGroupsQuery($username: String, $internalId: String) {
    unified {
      unifiedProfile(
        unifiedProfileUsername: $username
        internalId: $internalId
      ) {
        ... on UnifiedProfile {
          id
          forums {
            ... on UnifiedForums {
              id
              groups {
                ... on UnifiedForumsGroupsConnection {
                  edges {
                    cursor
                    node {
                      viewHref
                      aaid
                      title
                      groupMemberCount
                      topicsCount
                      hasHiddenAncestor
                      joinDate
                      membershipType
                      avatar {
                        mediumHref
                      }
                    }
                  }
                  totalCount
                }
              }
            }
          }
        }
      }
    }
  }
`;
